import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";

// A QuickBooks job's delivery address, already chosen on the job page —
// shown on purchase forms instead of asking for it again (Test Drive
// 2026-10-21). Changing it happens on the job.
export default function JobDeliveryAddress({ address, jobId, testId = "job-delivery-address" }) {
  if (!address) return null;
  return (
    <div className="mt-1.5 rounded-lg border border-slate-200 bg-slate-50 px-3 py-2.5 text-[13px]" data-testid={testId}>
      <div className="flex gap-2">
        <MapPin size={13} className="text-slate-400 mt-0.5 shrink-0" />
        <div className="min-w-0">
          <div className="font-medium">{address.label}</div>
          <div className="text-slate-500 text-[12.5px]">
            {[address.address_line1, address.city, address.state, address.zip].filter(Boolean).join(", ")}
          </div>
          <div className="text-[11.5px] text-slate-400 mt-1">
            Set on the job.{jobId && <> <Link to={`/contractor/jobs/${jobId}`} className="text-sky-600 font-semibold">Change it on the job page</Link></>}
          </div>
        </div>
      </div>
    </div>
  );
}
